import { DeliveryDay } from '../../api/company/types';

export const week = [
  { title: 'MON', longTitle: 'monday', key: DeliveryDay.MONDAY, id: 1 },
  { title: 'TUE', longTitle: 'tuesday', key: DeliveryDay.TUESDAY, id: 2 },
  { title: 'WED', longTitle: 'wednesday', key: DeliveryDay.WEDNESDAY, id: 3 },
  { title: 'THU', longTitle: 'thursday', key: DeliveryDay.THURSDAY, id: 4 },
  { title: 'FRI', longTitle: 'friday', key: DeliveryDay.FRIDAY, id: 5 },
  { title: 'SAT', longTitle: 'saturday', key: DeliveryDay.SATURDAY, id: 6 },
  { title: 'SUN', longTitle: 'sunday', key: DeliveryDay.SUNDAY, id: 0 },
];
